import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { ToolsPanelToggleButton } from "../../../screens/positions-and-orders/controls";
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import ArchitectureIcon from '@mui/icons-material/Architecture';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import { ProfileType } from "../../options-table/types/ProfileType";

export function TripleCustomBalanceToggle() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();

    const isCustomBalanceEnabled = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.selectedProfileTypes.indexOf(ProfileType.Custom) > -1
        : false;
    
    const isEnabled = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.isTripleCustomBalanceEnabled
        : false;

    const isUsingEqualShifts = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.isTripleCustomBalanceUsingEqualShifts
        : false;

    useEffect(() => {
    }, [selectedPortfolio]);

    const onEnabledChanged = async () => {
        const newValue = !isEnabled;

        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.isTripleCustomBalanceEnabled = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }

    const onUsingEqualShiftsChanged = async () => {
        const newValue = !isUsingEqualShifts;

        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.isTripleCustomBalanceUsingEqualShifts = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <Stack direction="row" spacing={0.5}>
            <ToolsPanelToggleButton
                isActivated={isEnabled}
                setIsActivated={onEnabledChanged}
                tooltipTextWhenActivated="Hide triple custom profile balance lines"
                tooltipTextWhenDeactivated="Show triple custom profile balance lines"
                disabled={!isCustomBalanceEnabled}
            >
                <AddRoadIcon
                    sx={{
                        height: '18px',
                        width: '18px',
                    }}
                />
            </ToolsPanelToggleButton>
            <ToolsPanelToggleButton
                isActivated={isUsingEqualShifts}
                setIsActivated={onUsingEqualShiftsChanged}
                tooltipTextWhenActivated="Calculate the second and third custom balance lines by proportionally dividing the remaining time to expiration between them"
                tooltipTextWhenDeactivated="Calculate the second and third custom balance lines using the same time interval from the current date/time as the first balance line"
                disabled={!isEnabled || !isCustomBalanceEnabled}
            >
                <ArchitectureIcon
                    sx={{
                        height: '18px',
                        width: '18px',
                    }}
                />
            </ToolsPanelToggleButton>
        </Stack>
    )
}